const TOKEN_KEY = "accessToken";
const REFRESH_TOKEN_KEY = "refreshToken";
const LANGUAGE_KEY = "language";
const ROLE = "role";
const TAB = "tab";
const RULE = "rule";
const FIRST_ACCESS = "firstAccess";
const IS_ACCEPT_TERM = "isAcceptTerm";

const TokenService = {
  getToken(): string {
    return JSON.parse(localStorage.getItem(TOKEN_KEY) || "null");
  },
  saveToken(accessToken: string): void {
    localStorage.setItem(TOKEN_KEY, accessToken);
  },
  removeToken(): void {
    localStorage.removeItem(TOKEN_KEY);
  },
  getRefreshToken(): string {
    return JSON.parse(localStorage.getItem(REFRESH_TOKEN_KEY) || "null");
  },
  saveRefreshToken(refreshToken: string): void {
    localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
  },
  removeRefreshToken(): void {
    localStorage.removeItem(REFRESH_TOKEN_KEY);
  },
  getLanguage(): string | null {
    return localStorage.getItem(LANGUAGE_KEY) || null;
  },
  saveLanguage(language: string): void {
    localStorage.setItem(LANGUAGE_KEY, language);
  },
  getRole(): string {
    return localStorage.getItem(ROLE) || "null";
  },
  saveRole(role: string): void {
    localStorage.setItem(ROLE, role);
  },
  removeRole(): void {
    localStorage.removeItem(ROLE);
  },
  getTab(routeKey?: string): string {
    const key = routeKey ? `${TAB}_${routeKey}` : TAB;
    return JSON.parse(localStorage.getItem(key) || "0");
  },
  saveTab(tab: string, routeKey?: string): void {
    const key = routeKey ? `${TAB}_${routeKey}` : TAB;
    localStorage.setItem(key, tab);
  },
  removeTab(routeKey?: string): void {
    const key = routeKey ? `${TAB}_${routeKey}` : TAB;
    localStorage.removeItem(key);
  },
  getRule(): string {
    return localStorage.getItem(RULE) || "null";
  },
  saveRule(rule: string): void {
    localStorage.setItem(RULE, rule);
  },
  removeRule(): void {
    localStorage.removeItem(RULE);
  },
  getFirstAccess(): string {
    return localStorage.getItem(FIRST_ACCESS) || "null";
  },
  saveFirstAccess(firstAccess: string): void {
    localStorage.setItem(FIRST_ACCESS, firstAccess);
  },
  removeFirstAccess(): void {
    localStorage.removeItem(FIRST_ACCESS);
  },
  getIsAcceptTerm(): string | boolean {
    return JSON.parse(localStorage.getItem(IS_ACCEPT_TERM) || "null");
  },
  saveIsAcceptTerm(isAcceptTerm: string): void {
    localStorage.setItem(IS_ACCEPT_TERM, isAcceptTerm);
  },
  removeIsAcceptTerm(): void {
    localStorage.removeItem(IS_ACCEPT_TERM);
  },
};

export { TokenService };
